import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { IAppConfig } from './_models/app-config.model';

@Injectable()
export class AppConfig {

    static settings: IAppConfig;

    constructor(private http: HttpClient) { }

    load() {
        const jsonFile = `assets/config/config.${environment.production ? 'deploy' : 'dev'}.json`;
        return new Promise((resolve, reject) => {
            let apiURL = jsonFile;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        console.log("Data " + res);

                        resolve();
                    }
                ).catch(
                    err => {
                        console.log("err :" + err);
                        reject("error config load "+ err);
                    }
                );
        });

        // return new Promise<void>((resolve, reject) => {
        //     this.http.get(jsonFile).toPromise().then((response: any) => {
        //         console.log("rsp : " + JSON.stringify(response));
        //         AppConfig.settings = <IAppConfig>response;
        //         resolve();
        //     }).catch((response: any) => {
        //         reject(`error in load file '${jsonFile}': ${JSON.stringify(response)}`);
        //     });
        // });

        // return this.http.get(jsonFile).subscribe(data => {
        //     console.log("data: " + data);
        //     try{
        //     AppConfig.settings = <IAppConfig> data;
        //     }
        //     catch(ex)
        //     {
        //         console.log("Error settings :"+ ex);
        //     }
        // });

        // return new Promise<void>((resolve, reject) => {
        //     this.http.get(jsonFile).toPromise().then((response: Response) => {
        //         console.log("rsp : " + response.text());
        //         AppConfig.settings = <IAppConfig>response.json();
        //         resolve();
        //     }).catch((response: any) => {
        //         reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
        //     });
        // });
    }
}